export default class Registration {
    selectors = {
        errMsg: '.registration span.message, .registration label.error span , .registration .captcha-form .error ',
        registrationSubmitted: '.registration-completed',
        registrationCompleted: '[registrationCompleted = true]',
    };

    elements = {
        errMsg: null,
        registrationSubmitted: null,
        registrationCompleted: null,
    };

    variables = {
        navigationEntries: window.performance.getEntriesByType('navigation'),
    };

    constructor() {
        this.init();
    }

    init() {
        this.setElements();
        this.eventListeners();
        this.RegistrationEvents();
    }

    setElements() {
        this.elements.errMsg = document.querySelectorAll(this.selectors.errMsg);
        this.elements.registrationSubmitted = document.querySelector(this.selectors.registrationSubmitted);
        this.elements.registrationCompleted = document.querySelector(this.selectors.registrationCompleted);
    }

    eventListeners() {
        this.elements.errMsg.length && window.addEventListener('load', this.errMsgsHandler);
    }

    errMsgsHandler = () => {
        let errMsgsArr = [];
        this.elements.errMsg.forEach(errMsg => {
            const firstPartOfTheMsg = errMsg.closest('label')?.textContent;
            const lastPartOfTheMsg = errMsg.textContent?.replaceAll('-', '').trim();
            const msg = `${firstPartOfTheMsg ? firstPartOfTheMsg : ''} ${lastPartOfTheMsg}`.replaceAll('*', '');
            errMsgsArr.push(msg);
        });
        const errMsg = errMsgsArr.toString().replaceAll(',', ' ');
        UX.utils.screenReaderSpeak(`Your registration cannot be completed. ${errMsg}`);

        if (window.adobeDataLayer) {
            const navigationEntries = window.performance.getEntriesByType('navigation');
            if (navigationEntries.length > 0 && navigationEntries[0].type === 'navigate') {
                UX.adobeDigitalData.registrationEvents.error(errMsgsArr.toString());
            }
        }
    };

    RegistrationEvents = () => {
        if (window.adobeDataLayer && this.elements.registrationSubmitted) {
            UX.adobeDigitalData.registrationEvents.submitted();
        }
        if (window.adobeDataLayer && this.elements.registrationCompleted) {
            UX.adobeDigitalData.registrationEvents.completed();
        }
    };
}
